import { defu } from 'defu'
import type { UseFetchOptions } from 'nuxt/app'

export const useApi = <T>(
  url: MaybeRefOrGetter<string>, 
  options: UseFetchOptions<T> = {}
): any => {
  const { status, data }: any = useAuth();
  let accessToken = null;

  if(status.value === 'authenticated' && data.value) {
    accessToken = data.value.accessToken;
  }
 
  let defaults: UseFetchOptions<T> = {
    key: toValue(url),
    headers: { 
      ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {})
    },
  }

  // Merge provided options with defaults using defu
  const mergedOptions: UseFetchOptions<T> = defu(options, defaults);

  // Unwrap any reactive values in mergedOptions
  const finalOptions: UseFetchOptions<T> = {
    ...mergedOptions,
    method: mergedOptions.method ? toValue(mergedOptions.method) : undefined,
    baseURL: mergedOptions.baseURL ? toValue(mergedOptions.baseURL) : undefined,
    key: mergedOptions.key ? toValue(mergedOptions.key) : undefined,
    headers: mergedOptions.headers ? toValue(mergedOptions.headers) : undefined,
  };

  // Unwrap URL
  const resolvedUrl = toValue(url);
  
  return (process.client && typeof window !== 'undefined' && document.readyState === 'complete')
    ? $fetch(resolvedUrl, finalOptions as any).catch(error => {
        if (error.response) throw error;
        throw new Error('Network error or unexpected issue occurred');
      })
    : useFetch(resolvedUrl, finalOptions).then(response => response.data as T).catch(error => {
        if (error.response) throw error;
        throw new Error('Network error or unexpected issue occurred');
      });
}